module.exports = __webpack_public_path__ + "img/marker_one_cyan1.6892fd3a.png";